import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import {
  LivePopupModule,
  ModalModule,
  SvgIconModule,
  TrAccordionModule,
  TrLoadingOverlayModule
} from '@toro/common/shared/components';
import { TooltipDirectiveModule } from '@toro/common/shared/directives';
import { HomeTraderBalanceComponent } from './home-trader-balance/home-trader-balance.component';
import { HomeTraderBarComponent } from './home-trader-bar/home-trader-bar.component';
import { TraderBarCardComponent } from './home-trader-bar/trader-bar-card/trader-bar-card.component';
import { HomeTraderClubComponent } from './home-trader-club/home-trader-club.component';
import { HomeTraderCoursesComponent } from './home-trader-courses/home-trader-courses.component';
import { HomeTraderTipsComponent } from './home-trader-tips/home-trader-tips.component';
import { HomeTraderComponent } from './home-trader.component';
import { STVMDigitalComponent } from '../../components/stvm-digital/stvm-digital.component';
import { HomeLineChartModule } from '@hub-workspace/apps/logged-home/src/app/shared/components/home-line-chart/home-line-chart.module';
import { DayTradeCourseCardComponent } from '../../components/day-trade-course-card/day-trade-course-card.component';
import { TraderTrialModalComponent } from './home-trader-club/trader-trial-modal/trader-trial-modal.component';

@NgModule({
  declarations: [
    HomeTraderComponent,
    HomeTraderBarComponent,
    HomeTraderClubComponent,
    HomeTraderTipsComponent,
    HomeTraderCoursesComponent,
    TraderBarCardComponent,
    HomeTraderBalanceComponent,
    STVMDigitalComponent,
    DayTradeCourseCardComponent,
    TraderTrialModalComponent
  ],
  imports: [
    CommonModule,
    SvgIconModule,
    HomeLineChartModule,
    TooltipDirectiveModule,
    MatProgressBarModule,
    TrAccordionModule,
    ModalModule,
    TrLoadingOverlayModule,
    LivePopupModule,
  ],
  exports: [
    HomeTraderComponent,
    STVMDigitalComponent,
    DayTradeCourseCardComponent,
    HomeTraderBarComponent
  ]
})
export class HomeTraderModule {}
